import { INCREASE_TYPE } from './enum';
const {
    lang: { LANG_ENUM }
} = require('@futuweb/fego-bridge');
const { useI18n } = require('@fegobull/webapi').use;

const langTextMap = {
    [LANG_ENUM.CN]: {
        [INCREASE_TYPE.WEEK]: '近一周涨跌幅',
        [INCREASE_TYPE.MONTH]: '近一月涨跌幅',
        [INCREASE_TYPE.YEAR]: '近一年涨跌幅',
        [INCREASE_TYPE.YEAR_TO_DATE]: '年初至今涨跌幅',
        aum: '资产规模：',
        divYield: '股息率：',
        addSelectedSucc: '添加成功',
        delSelectedSucc: '已从自选删除',
        tenMillion: '亿',
        tenThousand: '万',
        loading: '加载中...'
    },
    [LANG_ENUM.HK]: {
        [INCREASE_TYPE.WEEK]: '近一週漲跌幅',
        [INCREASE_TYPE.MONTH]: '近一月漲跌幅',
        [INCREASE_TYPE.YEAR]: '近一年漲跌幅',
        [INCREASE_TYPE.YEAR_TO_DATE]: '年初至今漲跌幅',
        aum: '資產規模：',
        divYield: '股息率：',
        addSelectedSucc: '新增成功',
        delSelectedSucc: '已從自選刪除',
        tenMillion: '億',
        tenThousand: '萬',
        loading: '加载中...'
    },
    [LANG_ENUM.EN]: {
        [INCREASE_TYPE.WEEK]: '1W %CHG',
        [INCREASE_TYPE.MONTH]: '1M %CHG',
        [INCREASE_TYPE.YEAR]: '1Y %CHG',
        [INCREASE_TYPE.YEAR_TO_DATE]: 'YTD %CHG',
        aum: 'AUM: ',
        divYield: 'Div Yield: ',
        addSelectedSucc: 'Added Successfully',
        delSelectedSucc: 'Deleted',
        billion: 'B',
        million: 'M',
        loading: 'Loading...'
    },
    [LANG_ENUM.JA]: {
        [INCREASE_TYPE.WEEK]: '株価変化率(前週比)',
        [INCREASE_TYPE.MONTH]: '株価変化率(前月比)',
        [INCREASE_TYPE.YEAR]: '株価変化率(前年比)',
        [INCREASE_TYPE.YEAR_TO_DATE]: '株価変化率(年初来)',
        aum: '運用資産：',
        divYield: '配当利回：',
        addSelectedSucc: '追加完了',
        delSelectedSucc: 'お気に入りから削除されました',
        tenMillion: '億',
        tenThousand: '万',
        loading: '読み込み中...'
    },
    [LANG_ENUM.FR]: {
        [INCREASE_TYPE.WEEK]: '1W %CHG',
        [INCREASE_TYPE.MONTH]: '1M %CHG',
        [INCREASE_TYPE.YEAR]: '1Y %CHG',
        [INCREASE_TYPE.YEAR_TO_DATE]: 'YTD %CHG',
        aum: 'AUM: ',
        divYield: 'Div Yield: ',
        addSelectedSucc: 'Added Successfully',
        delSelectedSucc: 'Deleted',
        billion: 'B',
        million: 'M',
        loading: 'Loading...'
    }
};

const $t = useI18n(langTextMap);

export default $t;
